
import Parchment from 'parchment';


class Image extends Parchment.Embed {
  static create({ value }) {
    let node = super.create();
    if (typeof value === 'string') {
      node.setAttribute('src');
    }
    return node;
  }

  static value(domNode) {
    return  domNode.getAttribute('src');
  }

}
Image.blotName = 'image';
Image.tagName = 'IMG';


export default Image;

// import Quill from 'quill';

// const BlockEmbedHtml = Quill.import('blots/block/embed');

// class EmbedHtmlBlot extends BlockEmbedHtml {
//   static create({ value, shortId }) {
//     const node = super.create();

//     node.setAttribute('src', value);
//     node.setAttribute('class', 'custom-ql-image');
//     node.setAttribute('id', `blot-custom-id---${shortId}`);

//     return node;
//   }

//   static value(node) {
//     return { value: node.getAttribute('src'), shortId: node.id.split('---').at(-1) };
//   }
// }

// EmbedHtmlBlot.blotName = embedBlotName;
// EmbedHtmlBlot.tagName = 'img';
// Quill.register(EmbedHtmlBlot);
